<span kendoPopoverAnchor [popover]="popoverRef" #anchor="kendoPopoverAnchor" showOn="hover"
  class="cursor-pointer d-flex align-items-center">
  <span class="same-workday-color"><ng-content></ng-content></span>
  <i class="fa-solid fa-triangle-exclamation same-workday-color ml-1"></i>
</span>

<kendo-popover [callout]="true" #popoverRef>
  <ng-template kendoPopoverBodyTemplate>
    <div class="popover-wrapper">
      <ul class="list-unstyled mb-0">
        <li *ngFor="let inv of investigations" class="mb-1">
          <a [routerLink]="['/investigations/', inv.id]" [queryParams]="{ tab: 'expenses' }" target="_blank"
            class="linkmd">
            {{ inv.nefcoNumber }}
          </a>
        </li>
      </ul>
    </div>
  </ng-template>
</kendo-popover>
